export const LIB_VERSION = '18.1.1'; // autogenerated
//# sourceMappingURL=version.js.map